import React, { useEffect, useRef } from 'react';
import './CompanyPartners.scss';
import imgone from "../../assets/OurPartnersPics/microsoft-6.svg";
import imgtwo from "../../assets/OurPartnersPics/dell-2.svg";
import imgthree from "../../assets/OurPartnersPics/apple-14.svg";
import imgfour from "../../assets/OurPartnersPics/hp-5.svg";
import imgfive from "../../assets/OurPartnersPics/intel.svg";
import imgsix from "../../assets/OurPartnersPics/nvidia.svg";
import imgseven from "../../assets/OurPartnersPics/hikvision-logo.svg";
import imgeight from "../../assets/OurPartnersPics/d-link-logo-1.svg";
import imagenine from "../../assets/OurPartnersPics/Advantech-Logo-new.png";

// Company logos using imported images
const companyLogos = [
  { id: 1, name: 'MiCROSOFT', src: imgone },
  { id: 2, name: 'DELL', src: imgtwo },
  { id: 3, name: 'APPLE', src: imgthree },
  { id: 4, name: 'HP', src: imgfour },
  { id: 5, name: 'INTEL', src: imgfive },
  { id: 6, name: 'NVIDIA', src: imgsix },
  { id: 7, name: 'HIKVISION', src: imgseven },  
  { id: 8, name: 'DLINK', src: imgeight },
  {id: 9, name: 'ADVANTECH', src: imagenine}
];

const CompanyPartners = () => {
  const logoContainerRef = useRef(null);

  useEffect(() => {
    const originalLogos = logoContainerRef.current.querySelectorAll('.logo-item');
    originalLogos.forEach(logo => {
      const clone = logo.cloneNode(true);
      logoContainerRef.current.appendChild(clone);
    });
  }, []);

  return (
    <section 
      id="company-partner"
      className="company-partners common-padding"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      <div className='container'>
        <div className="section-title our-partners-div">
          <span>Our Partners</span>
          <h2>Powering Innovation Together With Industry Leaders</h2>
        </div>
        
        <div className="logos-container">
          <div className="logos-scroll" ref={logoContainerRef}>
            {companyLogos.map((logo, index) => (
              <div className="logo-item" key={`${logo.id}-${index}`}>
                <img 
                  src={logo.src} 
                  alt={logo.name} 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyPartners;